module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23435",
      "conversations-internal-schema": "static-1.11448",
      "head-dlb": "static-1.4003",
      "hs-test-utils": "static-1.6793",
      "hubspot-url-utils": "static-1.3155",
      "HubStyleTokens": "static-2.10293",
      "I18n": "static-7.1391",
      "jasmine-runner": "static-1.5201",
      "quartz": "static-1.5548",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.461",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4306",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4766",
      "raven-hubspot": "static-1.5073",
      "bend-plugin-trellis-migration": "static-1.2447",
      "moment": "static-3.26",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4767",
      "transmute": "static-2.29",
      "HeadJS": "static-2.577",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.5992",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1904",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.120",
      "foundations-theming": "static-1.3115",
      "i18n-data": "static-1.197",
      "metrics-js": "static-1.8568",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4317",
      "jasmine": "static-4.3136",
      "quartz-core-utils": "static-1.2415",
      "csstype": "static-1.38",
      "copilot-toolkit": "static-1.6339",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.648",
      "hub-http-shared-msw-handlers": "static-1.7054",
      "hubspotter-http": "static-1.3579",
      "hubspotter-http-shared-msw-handlers": "static-1.7052",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11206",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15374",
      "react-router-dom": "static-5.26",
      "styled-components": "static-2.64",
      "ui-fonts": "static-1.332",
      "UIComponents": "static-3.7241",
      "bend-plugin-foundations-components": "static-1.2260",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3721",
      "foundations-theming-specialty": "static-1.832",
      "hs-story-utils": "static-1.8190",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.832",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-foundations-theming": "static-1.1598",
      "foundations-theming-base": "static-1.2100",
      "chatspot-client-types": "static-1.8564",
      "chatspot-core": "static-1.15573",
      "ts-schema": "static-1.3128",
      "sassPrefix": "static-1.131",
      "platform-infra-nav-components": "static-1.6687",
      "classnames": "static-2.10",
      "cssUtils": "static-1.493",
      "HubStyle": "static-2.10602",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23435",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11448",
      "head-dlb": "/head-dlb/static-1.4003",
      "hs-test-utils": "/hs-test-utils/static-1.6793",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3155",
      "HubStyleTokens": "/HubStyleTokens/static-2.10293",
      "I18n": "/I18n/static-7.1391",
      "jasmine-runner": "/jasmine-runner/static-1.5201",
      "quartz": "/quartz/static-1.5548",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4766",
      "raven-hubspot": "/raven-hubspot/static-1.5073",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2447",
      "moment": "/moment/static-3.26",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4767",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.577",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.5992",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1904",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.120",
      "foundations-theming": "/foundations-theming/static-1.3115",
      "i18n-data": "/i18n-data/static-1.197",
      "metrics-js": "/metrics-js/static-1.8568",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4317",
      "jasmine": "/jasmine/static-4.3136",
      "quartz-core-utils": "/quartz-core-utils/static-1.2415",
      "csstype": "/csstype/static-1.38",
      "copilot-toolkit": "/copilot-toolkit/static-1.6339",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7054",
      "hubspotter-http": "/hubspotter-http/static-1.3579",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7052",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11206",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15374",
      "react-router-dom": "/react-router-dom/static-5.26",
      "styled-components": "/styled-components/static-2.64",
      "ui-fonts": "/ui-fonts/static-1.332",
      "UIComponents": "/UIComponents/static-3.7241",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2260",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3721",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.832",
      "hs-story-utils": "/hs-story-utils/static-1.8190",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.832",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1598",
      "foundations-theming-base": "/foundations-theming-base/static-1.2100",
      "chatspot-client-types": "/chatspot-client-types/static-1.8564",
      "chatspot-core": "/chatspot-core/static-1.15573",
      "ts-schema": "/ts-schema/static-1.3128",
      "sassPrefix": "/sassPrefix/static-1.131",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6687",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.493",
      "HubStyle": "/HubStyle/static-2.10602",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};